import { Controller } from "stimulus";
import _upperFirst from "lodash/upperFirst";

export default class extends Controller {
  static targets = ["socialNetworkSelect", "addSocialNetworkContainer"];

  static values = {
    options: Array,
  };

  connect() {
    if (this.optionsValue.length) {
      this.initOptions();
      this.addSocialNetworkContainerTarget.classList.remove("d-none");
    }
  }

  deleteChosenOptionFromSelect(optionName) {
    document.getElementById(`option-${optionName}`).remove();
  }

  initOptions() {
    this.optionsValue.forEach((option) => {
      this.socialNetworkSelectTarget.insertAdjacentHTML(
        "beforeend",
        `<option id="option-${option.name}" value="${option.name}">${_upperFirst(option.name)}</option>`
      );
    });
  }

  handleSelectChange(event) {
    this.showSelectedOption(event.currentTarget.value);
    this.deleteChosenOptionFromSelect(event.currentTarget.value);
    this.resetSelect(event.currentTarget);
  }

  resetSelect(selectElement) {
    selectElement.selectedIndex = 0;
  }

  showSelectedOption(optionName) {
    document.getElementById(`input-${optionName}`).classList.remove("d-none");
  }
}
